import QueryString from 'rlink-querystring';




const RE_QUERY = /^(.*?)#?(\?.*)$/;
export default function routeInfoForPath ({routePatterns}, path) {
  let routePath = path;
  let params = {};

  let match = path.match(RE_QUERY);
  if (match) {
    let query, _;
    [_, routePath, query] = match;
    params = new QueryString(query).toSingleValueDict();
  }

  let matchingPatterns = routePatterns.filter(({reRoute}) => reRoute.test(routePath));
  if (matchingPatterns.length !== 1) {
    console.error(matchingPatterns);
    throw new Error(`Routed matching something other than exactly 1 route pattern (${matchingPatterns.length})- this can either mean the path being matched is not recognized, or too many paths match and we forgot to add some logic to pick the one we mean.`);
  }
  let {view, paramNameToGroupNum, reRoute} = matchingPatterns[0];
  let matches = reRoute.exec(routePath);
  for ( let [paramName, groupNum] of Object.entries(paramNameToGroupNum)) {
    if (paramName in params) {
      throw new Error(`Duplicate param '${paramName}' in route path '${path}'`);
    }
    params[paramName] = matches[groupNum];
  }
  return {view, params};
}



// WEBPACK FOOTER //
// ./lib/rlink-router/routeInfoForPath.js